import React, { Component } from 'react';
import ComponentBill from '../bill/ComponentBill';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillMount() {}

  handleClick = e => {};

  render() {
    return (
      <div className="mb16" id="bill">
        <ComponentBill
          {...this.props}
          dimenUuid={{ incubatorUuid: this.props.params.uuid }}
          pageSize={10}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageBill.js